/**
 * TypeBox schemas for Waypoint entity
 */

import { Type, type Static } from 'typebox'
import { UUID, ISODate, Coordinates, type Exact } from './common.js'

export const WaypointTypeSchema = Type.Union([
  Type.Literal('camp'),
  Type.Literal('water'),
  Type.Literal('danger'),
  Type.Literal('poi'),
  Type.Literal('emergency'),
  Type.Literal('custom'),
])

export const WaypointSchema = Type.Object({
  id: UUID,
  tripId: UUID,
  name: Type.String({ minLength: 1, maxLength: 100 }),
  description: Type.Optional(Type.String()),
  type: WaypointTypeSchema,
  coordinates: Coordinates,
  elevation: Type.Optional(Type.Number()),
  createdAt: ISODate,
  updatedAt: ISODate,
})
export type Waypoint = Exact<Static<typeof WaypointSchema>>

/** Fields required when creating a waypoint */
export const WaypointCreateSchema = Type.Object({
  tripId: UUID,
  name: Type.String({ minLength: 1, maxLength: 100 }),
  type: WaypointTypeSchema,
  coordinates: Coordinates,
})

/** Partial waypoint for updates */
export const WaypointUpdateSchema = Type.Partial(WaypointSchema)
